// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__242BK","footer":"Form_footer__3R82R"};